// -----------------------------------------------------------------------------
//
// This file defines Amplitude feature flags used in the application.
//
// Amplitude Feature Flags:
// https://app.amplitude.com/experiment/warnermusicgroup/flags
//
// -----------------------------------------------------------------------------
export const FEATURE_FLAGS = {
  ContainerSettings: 'container_settings_enabled',
  ContainerSettingsReadOnly: 'container_settings_read_only_enabled',
  ContainerSettingsPssf: 'container_settings_pssf_enabled',
  ContainerSettingsManageLabel: 'container_settings_manage_label_enabled',
  ContainerSettingsManageExternalUser:
    'container_settings_manage_external_user_enabled',
  ContainerSettingsLabelGroups: 'container_settings_label_groups_enabled',
  ContainerSettingsDropdownPagination:
    'container_settings_dropdown_pagination_enabled',
  ContainerProfile: 'container_profile_enabled',
  ContainerDdexConsole: 'container_ddex_console_enabled',
  SettingsInternalUserUpdates: 'settings_internal_user_updates',
  WmgAssetPerformance: 'wmg_asset_performance_enabled',
  WmgTrackDetails: 'wmg_track_details_enabled',
  WmgTrackPreReleases: 'wmg_track_pre_releases_enabled',
  WmgTrackSetBenchmarks: 'wmg_track_set_benchmarks_enabled',
  WmgTrackCompareBenchmark: 'wmg_track_compare_benchmark_enabled',
  WmgArtistContacts: 'wmg_artist_contacts_enabled',
  WmgArtistCollaboratorTracks: 'wmg_artist_collaborator_tracks_enabled',
  WmgCampaignBenchmarks: 'wmg_frontend_campaign_benchmarks',
  WmgMediaPlanCampaigns: 'wmg_frontend_media_plan_campaigns',
  WmgMarketingDigitalCampaignPerformanceDashboard:
    'wmg_marketing_digital_campaign_performance_dashboard',
  WmgHomepageUsesEmbeddedContent: 'wmg_homepage_uses_embedded_content',
  WmgUserManagement: 'wmg_user_management',
  WmgDigitalCampaignsMediaPlanningEnabled:
    'wmg_digital_campaigns_media_planning_enabled',
  WmgLabelPerfMaintenanceEnabled: 'wmg_label_perf_maintenance_enabled',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
